import { createRequestAtom } from '../utils/request-atom';
import { BusinessProfileDetails } from '../typings/business-profile';

export const businessProfileAtom = createRequestAtom<
    BusinessProfileDetails | undefined
>(undefined);
